import { Table, Space, Button } from "antd";

import CheckIcon from "@/icons/CheckIcon";
import PencilIcon from "@/icons/PencilIcon";
import TrashIcon from "@/icons/TrashIcon";

import CustomLink from "@/components/ui/CustomLink";

const disableDelete = (item) => {
  if (!item) return true;
  if (
    item.is_default ||
    (item.deleted && !item.can_be_deleted) ||
    (!item.can_be_deleted && !item.can_be_marked_deleted)
  )
    return true;
  return false;
};

// Таблица типов рабочих групп
// Содержит список с возможностью сортировки
// Тут можно настроить колонки
const UnitTypesTable = ({
  data,
  loading,
  pagination,
  onChange,
  onEditItem,
  onDeleteItem,
  scroll = { x: "100%" },
}) => {
  const columns = [
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
      sorter: {
        compare: (a, b) => a.name.localeCompare(b.name),
        multiple: 2,
      },

      render: (_, item) => {
        return (
          <CustomLink onClick={() => !item.is_default && onEditItem(item)}>
            {item.name}
          </CustomLink>
        );
      },
    },
    {
      title: "Основной тип",
      dataIndex: "is_default",
      key: "is_default",
      align: "center",
      render: (value) => (value ? <CheckIcon style={{ fontSize: 16 }} /> : ""),
    },
    {
      title: "Участвует в оргструктуре",
      dataIndex: "is_hierarchical",
      key: "is_hierarchical",
      align: "center",
      render: (value) => (value ? <CheckIcon style={{ fontSize: 16 }} /> : ""),
    },
    {
      title: "Удален",
      dataIndex: "deleted",
      key: "deleted",
      align: "center",
      render: (deleted) =>
        deleted ? <CheckIcon style={{ fontSize: 16 }} /> : "",
    },
    {
      title: "",
      width: 90,
      fixed: "right",
      align: "center",
      key: "actions",
      render: (_, item) => (
        <Space>
          <Button
            type="link"
            icon={<PencilIcon />}
            onClick={() => onEditItem(item)}
            disabled={item.is_default || item.deleted}
          ></Button>

          <Button
            type="link"
            icon={<TrashIcon />}
            disabled={disableDelete(item)}
            onClick={() => onDeleteItem(item)}
          ></Button>
        </Space>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      rowKey="uuid"
      loading={loading}
      pagination={pagination}
      onChange={onChange}
      showSorterTooltip={{
        target: "sorter-icon",
        title: "Нажмите для сортировки",
      }}
      scroll={scroll}
    />
  );
};

export default UnitTypesTable;
